import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, type SourceDrillRow } from '../api';

export function SourcePage() {
  const { ip } = useParams<{ ip: string }>();
  const [rows, setRows] = useState<SourceDrillRow[]>([]);

  useEffect(() => {
    if (!ip) return;
    api.source(ip).then((d) => setRows(d.rows));
  }, [ip]);

  return (
    <div className="card">
      <h2>Source IP {ip}</h2>
      {rows.length === 0 ? (
        <p className="muted">No records found for this IP.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Domain</th>
              <th>Provider</th>
              <th>Header-From</th>
              <th>Count</th>
              <th>Disposition</th>
              <th>DKIM</th>
              <th>SPF</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td className="muted">{new Date(r.date_begin).toISOString().slice(0, 10)}</td>
                <td>{r.domain}</td>
                <td>{r.org_name ?? '—'}</td>
                <td>{r.header_from ?? '—'}</td>
                <td>{r.count}</td>
                <td>{r.disposition ?? '—'}</td>
                <td>{r.dkim_aligned == null ? '—' : r.dkim_aligned ? '✓' : '✗'}</td>
                <td>{r.spf_aligned == null ? '—' : r.spf_aligned ? '✓' : '✗'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
